<template>
    <MicroAppPortfolioItemPage />
</template>

<script setup lang="ts">
import MicroAppPortfolioItemPage from '~/components/micro-app/MicroAppPortfolioItemPage.vue'
</script>
